<app-common-page-breadcrumbs [pageTitle]= "title" [navigationData]="navigationData"></app-common-page-breadcrumbs>
<div class="container py-5">
  <form (ngSubmit)="submit()" class="form-adjust " [formGroup]="forgetPasswordForm">
    <div class="form-group">
      <label>
        <div class="  ">{{'home.forgotPassword.forgot' | cxTranslate }} </div>
        <div class="text-dark  mb-4"> {{'home.forgotPassword.resetEmailSent' | cxTranslate }}</div>
        <span class=" strong mt-3">{{'home.forgotPassword.email' | cxTranslate }}</span>
        <div class="small text-secondary  mb-2">{{'home.forgotPassword.emailFormat' | cxTranslate }}</div>
        <input
          type="email"
          class="form-control form-control-lg text-secondary  mt-2"
          formControlName="email"
          placeholder= "{{'home.forgotPassword.emailPlaceholder' | cxTranslate }}"
        />
      </label>
      <div class="row mt-3" style="margin-left: 2.25rem !important;">
        <input formControlName="alternate" type="checkbox"/><a (click)="openpopup()" class="underline">{{'home.forgotPassword.alternateuse'| cxTranslate}} </a><span> {{'home.forgotPassword.altemailanotreceived'|cxTranslate}}</span>
      </div>
      <cx-form-errors [control]="forgetPasswordForm.get('email')" prefix="home"></cx-form-errors>
    </div>
    <!-- <div class="form-group">
      <span class="small text-secondary fs-10 text-black">{{ "home.quote.clickOnSave" | cxTranslate }}<a href="https://accounts.cn1.sapcdm.cn/accounts.store.downloadPublicConsentDocument?docID=30899863_807830496209_fc9a3f98cd31411ea21cf9c3ad76671d" target="_blank" class="small text-secondary fs-10 text-black">{{'home.quote.privacyPolicyLink' | cxTranslate }}</a> {{'home.quote.and' | cxTranslate}} <a class="small text-secondary fs-10 text-black" href="https://accounts.cn1.sapcdm.cn/accounts.store.downloadPublicConsentDocument?docID=30899863_807830496209_2c114fbeba884ddd912017197770667f" target="_blank">{{'home.quote.termsLink' | cxTranslate}}</a></span>
    </div> -->
  
    <button type="submit" class="btn btn-lg btn-block btn-primary rounded-1 md-font" [disabled]="!forgetPasswordForm.valid">
      {{'home.forgotPassword.btnResetMail' | cxTranslate }}
    </button>
    <button class="btn btn-lg btn-block btn-link rounded-1 md-font" (click)="backToLogin()">
      {{'home.forgotPassword.btnToLogin' | cxTranslate }}
     </button>
    <!-- <div *ngIf="loginData.error && notValidCreds" class="text-danger text-center mt-3 strong ">{{loginData.error}}</div> -->
  </form>
</div>




